import { css } from 'react-emotion'

const styles = {
  forgotPasswordForm: css({
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Pages/Auth/ForgotPasswordStyles.js